import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';
import { Addresses_FlowService } from './Addresses.flow.index';
import { Carriers_FlowService } from './Carriers.flow.index';
import { Materials_FlowService } from './Materials.flow.index';
import { PurchaseOrders_FlowService } from './PurchaseOrders.flow.index';
import { Inventory_FlowService } from './Inventory.flow.index';
import { InventoryCounts_FlowService } from './InventoryCounts.flow.index';
import { PrintNode_FlowService } from './PrintNode.flow.index';
import { WorkOrders_FlowService } from './WorkOrders.flow.index';
import { SalesOrders_FlowService } from './SalesOrders.flow.index';
import { Invoices_FlowService } from './Invoices.flow.index';
import { Notifications_FlowService } from './Notifications.flow.index';
import { Reports_FlowService } from './Reports.flow.index';
import { FootprintApiManager_FlowService } from './FootprintApiManager.flow.index';

import { app_custom_alerts_sendService } from './app.flow.index';
import { app_custom_cancel_sales_order_flowService } from './app.flow.index';
import { app_custom_charge_recurring_storageService } from './app.flow.index';
import { app_custom_clean_wave_tasksService } from './app.flow.index';
import { app_custom_dnsp_processService } from './app.flow.index';
import { app_custom_generic_log_writeService } from './app.flow.index';
import { app_custom_get_report_data_flowService } from './app.flow.index';
import { app_custom_save_order_audit_report_as_attachmentService } from './app.flow.index';
import { app_insert_lp_count_by_project_warehouse_snapshotService } from './app.flow.index';
import { app_lp_count_by_project_warehouse_flowService } from './app.flow.index';
import { app_recurring_cycle_count_flowService } from './app.flow.index';
import { app_remote_printing_handlerService } from './app.flow.index';
import { app_testing_charge_recurring_storageService } from './app.flow.index';
import { app_testing_get_lp_count_dataService } from './app.flow.index';
import { app_testing_populate_lp_count_snapshot_dataService } from './app.flow.index';
import { app_testing_put_lp_count_dataService } from './app.flow.index';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.Addresses = this.injector.get(Addresses_FlowService);
    this.Carriers = this.injector.get(Carriers_FlowService);
    this.Materials = this.injector.get(Materials_FlowService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_FlowService);
    this.Inventory = this.injector.get(Inventory_FlowService);
    this.InventoryCounts = this.injector.get(InventoryCounts_FlowService);
    this.PrintNode = this.injector.get(PrintNode_FlowService);
    this.WorkOrders = this.injector.get(WorkOrders_FlowService);
    this.SalesOrders = this.injector.get(SalesOrders_FlowService);
    this.Invoices = this.injector.get(Invoices_FlowService);
    this.Notifications = this.injector.get(Notifications_FlowService);
    this.Reports = this.injector.get(Reports_FlowService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_FlowService);
  }

    public Utilities: Utilities_FlowService;
    public Addresses: Addresses_FlowService;
    public Carriers: Carriers_FlowService;
    public Materials: Materials_FlowService;
    public PurchaseOrders: PurchaseOrders_FlowService;
    public Inventory: Inventory_FlowService;
    public InventoryCounts: InventoryCounts_FlowService;
    public PrintNode: PrintNode_FlowService;
    public WorkOrders: WorkOrders_FlowService;
    public SalesOrders: SalesOrders_FlowService;
    public Invoices: Invoices_FlowService;
    public Notifications: Notifications_FlowService;
    public Reports: Reports_FlowService;
    public FootprintApiManager: FootprintApiManager_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _custom_alerts_send: app_custom_alerts_sendService;
  public async custom_alerts_send($inParams: { application_name?: string, log_level?: number, log_input?: $frontendTypes.Utilities.Log, log_id?: string }): Promise< { success?: boolean, messages?: any[] }> {
    if(!this._custom_alerts_send) { 
      this._custom_alerts_send = this.injector.get(app_custom_alerts_sendService);
    }
    return this._custom_alerts_send.run($inParams);
  }
   
   

   
 
  private _custom_cancel_sales_order_flow: app_custom_cancel_sales_order_flowService;
  public async custom_cancel_sales_order_flow($inParams: { orderId: number }): Promise< { reason?: string }> {
    if(!this._custom_cancel_sales_order_flow) { 
      this._custom_cancel_sales_order_flow = this.injector.get(app_custom_cancel_sales_order_flowService);
    }
    return this._custom_cancel_sales_order_flow.run($inParams);
  }
   
   

   
 
  private _custom_charge_recurring_storage: app_custom_charge_recurring_storageService;
  public async custom_charge_recurring_storage($inParams: {  }): Promise< { debug_result?: string[] }> {
    if(!this._custom_charge_recurring_storage) { 
      this._custom_charge_recurring_storage = this.injector.get(app_custom_charge_recurring_storageService);
    }
    return this._custom_charge_recurring_storage.run($inParams);
  }
   
   

   
 
  private _custom_clean_wave_tasks: app_custom_clean_wave_tasksService;
  public async custom_clean_wave_tasks($inParams: { orderId?: number }): Promise< { reason?: string }> {
    if(!this._custom_clean_wave_tasks) { 
      this._custom_clean_wave_tasks = this.injector.get(app_custom_clean_wave_tasksService);
    }
    return this._custom_clean_wave_tasks.run($inParams);
  }
   
   

   
 
  private _custom_dnsp_process: app_custom_dnsp_processService;
  public async custom_dnsp_process($inParams: { debug?: boolean }): Promise< { results?: any[] }> {
    if(!this._custom_dnsp_process) { 
      this._custom_dnsp_process = this.injector.get(app_custom_dnsp_processService);
    }
    return this._custom_dnsp_process.run($inParams);
  }
   
   

   
 
  private _custom_generic_log_write: app_custom_generic_log_writeService;
  public async custom_generic_log_write($inParams: { application_name: string, process_name: string, log_level: number, message: string }): Promise<void> {
    if(!this._custom_generic_log_write) { 
      this._custom_generic_log_write = this.injector.get(app_custom_generic_log_writeService);
    }
    return this._custom_generic_log_write.run($inParams);
  }
   
   

   
 
  private _custom_get_report_data_flow: app_custom_get_report_data_flowService;
  public async custom_get_report_data_flow($inParams: { package_name: string, report_name: string, inputs?: any }): Promise< { report_data?: Blob }> {
    if(!this._custom_get_report_data_flow) { 
      this._custom_get_report_data_flow = this.injector.get(app_custom_get_report_data_flowService);
    }
    return this._custom_get_report_data_flow.run($inParams);
  }
   
   

   
 
  private _custom_save_order_audit_report_as_attachment: app_custom_save_order_audit_report_as_attachmentService;
  public async custom_save_order_audit_report_as_attachment($inParams: { order_id?: number }): Promise< { results?: any[] }> {
    if(!this._custom_save_order_audit_report_as_attachment) { 
      this._custom_save_order_audit_report_as_attachment = this.injector.get(app_custom_save_order_audit_report_as_attachmentService);
    }
    return this._custom_save_order_audit_report_as_attachment.run($inParams);
  }
   
   

   
 
  private _insert_lp_count_by_project_warehouse_snapshot: app_insert_lp_count_by_project_warehouse_snapshotService;
  public async insert_lp_count_by_project_warehouse_snapshot($inParams: {  }): Promise< { results?: string, debug_result?: string[] }> {
    if(!this._insert_lp_count_by_project_warehouse_snapshot) { 
      this._insert_lp_count_by_project_warehouse_snapshot = this.injector.get(app_insert_lp_count_by_project_warehouse_snapshotService);
    }
    return this._insert_lp_count_by_project_warehouse_snapshot.run($inParams);
  }
   
   

   
 
  private _lp_count_by_project_warehouse_flow: app_lp_count_by_project_warehouse_flowService;
  public async lp_count_by_project_warehouse_flow($inParams: { payload?: $frontendTypes.lp_count_by_project_warehouse_types[], action: string, skip?: number, take?: number, date_from?: string, date_to?: string, full_text_search?: string }): Promise< { payload?: $frontendTypes.lp_count_by_project_warehouse_types[], success?: boolean, error?: any[], count?: number }> {
    if(!this._lp_count_by_project_warehouse_flow) { 
      this._lp_count_by_project_warehouse_flow = this.injector.get(app_lp_count_by_project_warehouse_flowService);
    }
    return this._lp_count_by_project_warehouse_flow.run($inParams);
  }
   
   

   
 
  private _recurring_cycle_count_flow: app_recurring_cycle_count_flowService;
  public async recurring_cycle_count_flow($inParams: { warehouseId: number }): Promise< { error_details?: string, success_details?: string }> {
    if(!this._recurring_cycle_count_flow) { 
      this._recurring_cycle_count_flow = this.injector.get(app_recurring_cycle_count_flowService);
    }
    return this._recurring_cycle_count_flow.run($inParams);
  }
   
   

   
 
  private _remote_printing_handler: app_remote_printing_handlerService;
  public async remote_printing_handler($inParams: { printer_name: string, report_name: string, report_inputs: any, debug_mode?: boolean }): Promise< { debug?: any }> {
    if(!this._remote_printing_handler) { 
      this._remote_printing_handler = this.injector.get(app_remote_printing_handlerService);
    }
    return this._remote_printing_handler.run($inParams);
  }
   
   

   
 
  private _testing_charge_recurring_storage: app_testing_charge_recurring_storageService;
  public async testing_charge_recurring_storage($inParams: { projectId: number, warehouseId: number, startDate: string, endDate: string, debugMode?: boolean, pallet_amount?: number }): Promise< { debug_result?: string[] }> {
    if(!this._testing_charge_recurring_storage) { 
      this._testing_charge_recurring_storage = this.injector.get(app_testing_charge_recurring_storageService);
    }
    return this._testing_charge_recurring_storage.run($inParams);
  }
   
   

   
 
  private _testing_get_lp_count_data: app_testing_get_lp_count_dataService;
  public async testing_get_lp_count_data($inParams: { projectId: number, warehouseId: number, startDate: string, endDate: string, debugMode?: boolean }): Promise< { debug_result?: string[] }> {
    if(!this._testing_get_lp_count_data) { 
      this._testing_get_lp_count_data = this.injector.get(app_testing_get_lp_count_dataService);
    }
    return this._testing_get_lp_count_data.run($inParams);
  }
   
   

   
 
  private _testing_populate_lp_count_snapshot_data: app_testing_populate_lp_count_snapshot_dataService;
  public async testing_populate_lp_count_snapshot_data($inParams: { projectId: number, warehouseId: number, startDate: string, daysToAdd?: number, debugMode?: boolean }): Promise< { debug_result?: string[] }> {
    if(!this._testing_populate_lp_count_snapshot_data) { 
      this._testing_populate_lp_count_snapshot_data = this.injector.get(app_testing_populate_lp_count_snapshot_dataService);
    }
    return this._testing_populate_lp_count_snapshot_data.run($inParams);
  }
   
   

   
 
  private _testing_put_lp_count_data: app_testing_put_lp_count_dataService;
  public async testing_put_lp_count_data($inParams: { projectId: number, warehouseId: number, captureDate: string, lpCount: number, debugMode?: boolean }): Promise< { debug_result?: string[] }> {
    if(!this._testing_put_lp_count_data) { 
      this._testing_put_lp_count_data = this.injector.get(app_testing_put_lp_count_dataService);
    }
    return this._testing_put_lp_count_data.run($inParams);
  }
   
   

   
}
